import $ from 'jquery';
import { onAddLogoToCanvas } from '~src/image';
import { getState } from '~src/state';

export const displaySidebarLogos = async () => {
  const sidebarLogos = getState('sidebarLogos', { items: [] });
  if (sidebarLogos.items.length === 0) {
    $('#editor-sidebar-upload-btn-logo').text('Carica');
    const html = `<div class="containerTextEmptyBox" id="containerTextEmptyBoxLogo"
                    <div class="textEmptyBox">Non ci sono loghi
                    </div>
                  </div>`;
    $('#editor-sidebar-logo').html(html);
    return;
  }
  $('#editor-sidebar-upload-btn-logo').text('Sostituisci');

  const { ids, html } = sidebarLogos.items.reduce(
    (acc, item) => {
      const itemId = `editor-sidebar-add-logo-${item.objectId}`;

      acc.html += `<div
                    class="sidebar-item-grid-box image-square-container">
                      <div id="${itemId}" data-url="${item.url}" data-logo-type="${item.logoType}" class="sidebar-item-grid-box-click-listener"></div>
                      <img
                          src="../assets/svg/img-loader.gif"
                          class="lazy image-square"
                          data-src="${item.url}"
                      />
                  </div>`;

      acc.ids.push(`#${itemId}`);

      return acc;
    },
    { ids: [], html: '' }
  );

  if (ids.length) {
    ids.forEach((id) => {
      $('body').off('click', id, onAddLogoToCanvas);
      $('body').on('click', id, onAddLogoToCanvas);
    });
  }

  $('#editor-sidebar-logo').html(html);
  window.lazyLoadInstance.update();
};
